import { definePage } from '@reflex/plugin-api/web';
import type { PluginWebManifest } from '@reflex/plugin-api/web';

const page = definePage({
  path: '/databases',
  label: 'Databases',
  icon: 'Database',
  // Labs, not the app shell: the host derives the Labs takeover's plugin
  // paths from the `misc` and `plugins` groups, so this is what puts a
  // preview surface inside Labs instead of the sidebar's main column (an
  // icon in the bottom strip under the default sessions dock).
  group: 'plugins',
  componentPath: '@reflex/plugin-databases/web/DatabasesPage',
  maturityStage: 'preview',
  description: 'Durable tables agents and flows read and write.',
  details:
    'Create org-scoped databases stored in the SQLite database every Runloop Axon carries. Define tables with typed column schemas, then attach a database to an agent run: the agent gets a skill and scoped credentials for the on-box data API, including real SQL for joins and aggregations. Flows read and write the same tables through database actions.',
  features: [
    'Tables with typed column schemas, or schemaless JSON tables',
    'Attach a database to an agent run with read or read-write access',
    'Agents get an axon-database skill plus scoped API credentials',
    'Structured row endpoints with schema validation, plus raw SQL',
    'Flow actions to insert, update, delete, query, and run SQL',
  ],
});

export const databasesWeb: PluginWebManifest = {
  ...page.web,
  attachments: [
    {
      id: 'axon-database',
      label: 'Database',
      icon: 'Database',
      order: 40,
      pickerComponentPath: '@reflex/plugin-databases/web/DatabaseAttachmentPicker',
      summaryComponentPath: '@reflex/plugin-databases/web/DatabaseAttachmentSummary',
    },
  ],
};
